<template>
  <div id="sign-up" class="row">
    <div class="col-md-8 ml-auto mr-auto">
      <card type="user">
        <div class="card-header">
          <h5 class="title welcome-text">Sign Up form, please fill all fields</h5>
        </div>
        <div class="card-body">
          <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <a href="#">
              <img class="avatar" src="img/default.png" alt="...">
            </a>
          </div>
          <p></p>
          <form @submit.prevent>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="nickname"
                              type="text"
                              placeholder="Nickname"
                              v-model="logUp.user_name"
                              v-bind:error="errors.user_name"
                              v-bind:class="{ 'has-danger': !validation.user_name }">
                  </base-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="Email"
                              type="email"
                              placeholder="Email"
                              v-model="logUp.email"
                              v-bind:error="errors.email"
                              v-bind:class="{ 'has-danger': !validation.email }">
                  </base-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="First name"
                              type="text"
                              placeholder="First name"
                              v-model="logUp.first_name"
                              v-bind:error="errors.first_name"
                              v-bind:class="{ 'has-danger': !validation.first_name }">
                  </base-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="Last name"
                              type="text"
                              placeholder="Last name"
                              v-model="logUp.last_name"
                              v-bind:error="errors.last_name"
                              v-bind:class="{ 'has-danger': !validation.last_name }">
                  </base-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="Job description"
                              type="text"
                              placeholder="Description"
                              v-model="logUp.description"
                              v-bind:error="errors.description"
                              v-bind:class="{ 'has-danger': !validation.description }">
                  </base-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="Phone number"
                              type="phone_number"
                              placeholder="Phone number"
                              v-model="logUp.phone_number"
                              v-bind:error="errors.phone_number"
                              v-bind:class="{ 'has-danger': !validation.phone_number }">
                  </base-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="Password"
                              type="password"
                              placeholder="Enter password"
                              v-model="logUp.pwd"
                              v-bind:error="errors.pwd"
                              v-bind:class="{ 'has-danger': !validation.pwd }">
                  </base-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <base-input label="Confirm password"
                              type="password"
                              placeholder="Confirm password"
                              v-model="logUp.conf_pwd"
                              v-bind:error="errors.conf_pwd"
                              v-bind:class="{ 'has-danger': !validation.conf_pwd }">
                  </base-input>
                </div>
              </div>
            </div>
            <p>
              <br><br><br>
            </p>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <button type="button" class="btn btn-default btn-block" v-on:click="authentication()">Back</button>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <button type="button" class="btn btn-primary btn-block" v-on:click="add()">Create an account</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
    import {url} from "../../plugins/axios";
    import axios from "axios";
    import NotificationTemplate from "../Notifications/NotificationTemplate";

    export default {
      props: {
        activity: {
          type: Object,
          default: () => {
            return {};
          }
        }
      },
      name: "sign-up",
      data() {
        return {
          logUp: {
            'user_name' : '',
            'email' : '',
            'first_name' : '',
            'last_name' : '',
            'description' : '',
            'phone_number' : '',
            'pwd' : '',
            'conf_pwd' : '',
            'type_id' : 6,
            'project_id' : 2,
          },
          validation:{
            email:true,
            pwd:true,
            user_name:true,
            first_name:true,
            last_name:true,
            description:true,
            phone_number:true,
            conf_pwd:true,
          },
          errors:{
            email:'',
            pwd:'',
            user_name:'',
            first_name:'',
            last_name:'',
            description:'',
            phone_number:'',
            conf_pwd:'',
          },
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        authentication(){
          this.activity.signUp = false;
          this.activity.signIn = true;
        },
        validateFields(){
          this.validateUser_name(this.logUp.user_name);
          this.validateEmail(this.logUp.email);
          this.validateFirst_name(this.logUp.first_name);
          this.validateLast_name(this.logUp.last_name);
          this.validatePassword(this.logUp.pwd);
          this.validateSecPassword(this.logUp.conf_pwd);
        },
        validateUser_name(value){
          this.validation.user_name = (value !== '');
          this.errors.user_name = (value === '') ? 'username could not be empty' : '';
        },
        validateEmail(value){
          this.validation.email = (value !== '');
          this.errors.email = (value === '') ? 'Email could not be empty' : '';
        },
        validateFirst_name(value){
          this.validation.first_name = (value !== '');
          this.errors.first_name = (value === '') ? 'First name could not be empty' : '';
        },
        validateLast_name(value){
          this.validation.last_name = (value !== '');
          this.errors.last_name = (value === '') ? 'Last name could not be empty' : '';
        },
        validatePassword(value){
          this.validation.pwd = (value !== '');
          this.errors.pwd = (value === '') ? 'Password could not be empty' : '';
        },
        validateSecPassword(value){
          if (value === '' || value !== this.logUp.pwd){
            this.validation.conf_pwd = false;
            if (value === ''){this.errors.conf_pwd = 'Password could not be empty';}
            else{this.errors.conf_pwd = 'Passwords has to be identical';}
          }
          else{
            this.validation.conf_pwd = true;
            this.errors.conf_pwd = '';
          }

        },
        add(){
          this.validateFields();
          let valid = true;
          for(let elem in this.validation){
            valid *= this.validation[elem]
          }
          if (valid){
            axios
              .post(url + 'add-employees/',
            {data: this.logUp},
            {
              withCredentials:'include',
              crossDomain:true
            }
              )
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success', 'Your employee was added. Wait for approving your action.');
                  this.activity.signUp = false;
                  this.activity.signIn = true;
                }
                else {
                  this.notifyVue('danger', response.data.error);
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
              })
          }
        },
      },
    }
</script>

<style scoped>
  .welcome-text{
    font-size: 16px;
  }
  .has-danger:after{
    top:45px;
  }
</style>
